/* eslint-disable import/no-unresolved */
import React from 'react';

import Layout from '../../components/Layout';
import PartialsHeader from '../../components/Partials/PartialsHeader';
import HomeTestimonials from '../../components/Home/HomeTestimonials';
import CultureItem from '../../components/AboutUs/aboutUsPartials/CultureItem';
import ServicesHeading from '../../components/SoftwareServices/ServicesHeading';
import LandingPageInfoBox from '../../components/LandingPages/LandingPageInfoBox';
import SingleBox from '../../components/Careers/careersPartials/SingleBox';
import Banner from '../../components/service/Products/productsPartials/DevOpsBanner';
import ResultsCardSwiperSection from '../../components/ResultsCardSwiperSection';
import HomeKnowledge from '../../components/Home/HomeKnowledge';
import imagesPillarPages from '../../components/imagesPillarPages';
import imagesLandingPages from '../../components/imagesLandingPages';
import SectionJSCustomBoxes from '../../components/SoftwareServices/SectionJSCustomBoxes';
import TelecommunicationSection from '../../components/SoftwareServices/TelecommunicationSection';

import content from '../../components/SoftwareServices/content-javascript-development';

const SoftwareServices = () => {
  return (
    <Layout
      title="JavaScript software development | Ulam Labs"
      description="Build responsive and dynamic web applications that your customers will love with our JavaScript developers."
    >
      <PartialsHeader>
        <div className="container">
          <div className="content">
            <div className="body">
              <h1 className="title">JavaScript development services</h1>
            </div>
          </div>
        </div>
      </PartialsHeader>
      <ServicesHeading headingText={content.headingText} />
      <SectionJSCustomBoxes />
      <div className="container py-5">
        <div className="row flex-column">
          <div className="col">
            <h2 className="subtitle bigger">
              Choose the right frontend framework for your needs
            </h2>
            <div className="content">
              <p>
                We understand that every business is unique. That&apos;s why we
                offer the following frontend frameworks to cater to your
                multiple needs.
              </p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="work-with d-flex flex-column flex-md-row justify-content-between">
            <LandingPageInfoBox
              icon={imagesLandingPages.reactSVG}
              title="React"
              description="Dominating JavaScript library that is used for building robust and
                  dynamic web apps. It serves perfectly as a base in the development
                  of single-page or mobile applications."
            />
            <LandingPageInfoBox
              icon={imagesLandingPages.vueSVG}
              title="Vue"
              description="Progressive framework which makes application development smooth and easy.
              It is small in size and has a lightweight API library that simplifies the app development process."
            />
            <LandingPageInfoBox
              icon={imagesLandingPages.angularSVG}
              title="Angular"
              description="Structural framework for dynamic application development.
                  Angular.js allows you to bind data and eliminate most of the code
                  in order to prevent writing it. In short, less code with the same
                  astonishing effect."
            />
          </div>
        </div>
      </div>
      <div className="version-pillar" style={{ background: '#eaebf1' }}>
        <HomeTestimonials
          customTitle="What our clients say about out software development services?"
          customSubtitle="Founders, CEOs and top managers from all
          over the world value our services especially for smooth communication, expertise and timely product delicery. Read
          customer opinion which prove that we are perfect technology partner for you as well."
        />
      </div>
      <TelecommunicationSection
        telecomSectionData={content.telecomSectionData}
      />
      <div className="container-fluid padd-b">
        <div className="container py-5 ">
          <h2 className="subtitle bigger without">
            Why work with our JavaScript developers?
          </h2>
          <div className="company-presentation landing pt-3 pb-0">
            <div className="icon-items">
              <div className="row">
                <div className="work-with d-flex flex-column flex-md-row justify-content-between">
                  <CultureItem
                    mainText="JavaScript is rooted in our DNA"
                    secText="JavaScript accompanies our web development for over 8 years now."
                    img={imagesPillarPages.logoJS}
                  />
                  <CultureItem
                    mainText="Experienced developers"
                    secText="Work on a daily basis with skilled and experienced JavaScript
                    engineers."
                    img={imagesLandingPages.icon3SVG}
                  />
                  <CultureItem
                    mainText="Agile methodology"
                    secText="Get the best and the fastest solutions with our Scrum masters."
                    img={imagesPillarPages.icon2SVG}
                  />
                </div>
              </div>
              <div className="row">
                <div className="work-with d-flex flex-column flex-md-row justify-content-between">
                  <CultureItem
                    mainText="Excellent communication"
                    secText="Communication is as important for Ulam Labs as technical knowledge. 
                    You can be sure that we put effective and timely communication as one of our priorities."
                    img={imagesLandingPages.outcomeSVG}
                  />
                  <CultureItem
                    mainText="Complementary services"
                    secText="In addition to JavaScript development, we have everything you
                    need for a long-term, end-to-end tech partnership."
                    img={imagesLandingPages.icon4SVG}
                  />
                  <CultureItem
                    mainText="Client's trust"
                    secText="More than 90% of our customers come back with their new projects
                    and recommend our services."
                    img={imagesLandingPages.ourroleSVG}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container my-4 my-md-0 services-banner-top">
        <Banner
          customTitle="Our approach to software development"
          customSubtitle="Find out how we develop services in JavaScript for our clients"
        />
      </div>
      <div
        className="container-fluid dark-bg padd-t"
        style={{ backgroundColor: 'rgb(234, 235, 241)' }}
      >
        <div className="container">
          <div className="row">
            <h2 className="col subtitle without bigger">
              JavaScript projects we&apos;ve delivered
            </h2>
          </div>
        </div>
      </div>
      <div
        className="dark-bg js-swiper"
        style={{ backgroundColor: 'rgb(234, 235, 241)' }}
      >
        <ResultsCardSwiperSection
          title="See related projects"
          buttonsAround={false}
          className="basis-slider"
          useSpecificCases={[
            'cryptocurrency-lending-platform',
            'full-stack-support-mobile-operator',
            'software-for-construction-sector'
          ]}
          onlySlider
        />
      </div>
      <div className="version-pillar knowledge-services my-5 padd-b">
        <HomeKnowledge
          useSpecificPostsByTag={['Javascript']}
          customTitle="Read about JavaScript on our blog"
          customSubtitle="Our team of developers takes active part in
          creating educational and valuable content for our clients who are thinking about JavaScript web development.
          Read our blog to understand the technology better and know how to use JavaScript to solve a variety of real-world
          problems."
          versionPillar
        />
      </div>
      <div className="container my-4 my-md-0 services-banner-top">
        <Banner
          customTitle="Find out how we develop services in JavaScript for our clients"
          version="servicesPage"
        />
      </div>
      <div className="container-fluid" style={{ background: '#eaebf1' }}>
        <div className="version-pillar pb-5 container padd-t">
          <div className="info-box">
            <div style={{ background: '#eaebf1' }}>
              <h3 className="subtitle without bigger">
                What other services do we offer?
              </h3>
              <div className="row">
                <SingleBox
                  image={imagesLandingPages.pythonSVG}
                  heading="Python development"
                  url="/software-services/python-development/"
                />
                <SingleBox
                  image={imagesPillarPages.chainSVG}
                  heading="Blockchain development"
                  url="/software-services/blockchain-development/"
                />
                <SingleBox
                  image={imagesPillarPages.codeauditSVG}
                  heading="Code audit"
                  url="/software-services/code-audit/"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SoftwareServices;
